import { http } from "src/axios";
import { tryParseJson } from "src/utils/try-parse-json";
import type { ServerVendorAccount, ServerVendorAccountList } from "./types/server-vendor-account";

export interface GetVendorAccountsParams {
  vendorId: string | number;
}

export async function getVendorAccounts(
  { vendorId }: GetVendorAccountsParams,
  signal: AbortSignal,
): Promise<ServerVendorAccount[]> {
  const response = await http.get<ServerVendorAccountList>(`/api/v1/vendors/${vendorId}/accounts`, { signal });
  for (const account of response.data.accounts) {
    // server response returns SCOPES as a JSON string, we need to parse it
    account.SCOPES = tryParseJson(account.SCOPES as unknown as string) ?? account.SCOPES;
  }
  return response.data.accounts.sort((a, b) => a.ID - b.ID);
}

export interface SunsetVendorAccountsParams {
  accountIds: number[];
  /** YYYY-MM-DD */
  sunsetDate: string;
  notes?: string;
}

export async function sunsetVendorAccounts({
  accountIds,
  sunsetDate,
  notes,
}: SunsetVendorAccountsParams): Promise<void> {
  await http.post(`/api/v2/accounts/sunset`, { account_ids: accountIds, sunset_date: sunsetDate, notes });
}
